import { useMemo } from 'react';
import { getMakeTFLState } from '../store/selectors/getMakeTFL';
import { useSelector } from 'react-redux';
import wrapWithTFL from '../utils/wrapWithTFL';

const useMakeTFL = () => {
    const makeTFL = useSelector(getMakeTFLState);

    return useMemo(() => {
        return (linkUrl, component) => {
            return wrapWithTFL(linkUrl, makeTFL, component);
        };
    }, [makeTFL]);
};

export default useMakeTFL;
